import React from 'react';

export default () => {
  const tips = [
    ['1 Layer', '0.004 in', '0.006 in'],
    ['2 Layer', '0.006 in', '0.010 in'],
    ['3 Layer', '0.008 in', '0.024 in'],
    ['4 Layer', '0.010 in', '0.024 in'],
    ['5 Layer', '0.012 in', '0.024 in'],
    ['6 Layer', '0.016 in', '0.024 in'],
  ];
  return (
    <div className="tip-item">
      <div className="title">Available thicknesses for Flex Circuits</div>
      <div className="row">
        <div className="col-md-6">
          <table className="table table-bordered table-striped table-thickness-tip">
            <thead>
              <tr>
                <th />
                <th>Min. Thickness</th>
                <th>Max. Thickness</th>
              </tr>
            </thead>
            <tbody>
              {tips.map((item, idx) => (
                <tr key={idx}>
                  <td>{item[0]}</td>
                  <td>{item[1]}</td>
                  <td>{item[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
